/**
 * Editorial content for the IPO Performance page (/ipo-performance):
 * disclaimers. No listing-price data lives here.
 */

// Methodology notes shown under the table; the page appends the "current as of" line
export const PERFORMANCE_DISCLAIMERS = [
  'Stock splits are adjusted backwards into historical issue prices.',
  "Bonuses, dividends, or other corporate actions are not factored when calculating raw 'Profit / Loss' percentage.",
  'Records on this page are sorted by default in descending order of the IPO listing date.',
  'Please check NSE / BSE websites for real-time live trading quotes, order book depth, and minute charts.',
];

